import { render, staticRenderFns } from "./slot-selector.vue?vue&type=template&id=22eed84c&scoped=true&"
import script from "./slot-selector.vue?vue&type=script&lang=ts&"
export * from "./slot-selector.vue?vue&type=script&lang=ts&"
import style0 from "./slot-selector.vue?vue&type=style&index=0&id=22eed84c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eed84c",
  null
  
)

export default component.exports